import React from 'react';
import styles from '../header-bar-styles';

export default function HeaderMenus(props) {
    return (
        <div style={styles.menusWrap}>{props.children}</div>
    );
}



// WEBPACK FOOTER //
// ./src/app-header/menus/HeaderMenus.js